import { createVNode as l, mergeProps as m } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ImportFilled.js";
import p from "../components/PfIcon.js";
const r = (t, o) => {
  const e = {
    ...t,
    ...o.attrs
  };
  return l(p, m(e, {
    icon: i
  }), null);
};
r.displayName = "ImportFilled";
r.inheritAttrs = !1;
export {
  r as default
};
